import type { CSSProperties, ReactElement } from "react";
import type { Site } from "@/types/sites";
import { useEffect } from "react";
import Script from "next/script";

export const Analytics = ({ site }: { site: Site | null }): ReactElement => {
    const siteAttrs = site?.attributes;
    const googleTagManagerContainerId = siteAttrs?.googleTagManagerContainerId;
    const googleOptimizeContainerId = siteAttrs?.googleOptimizeContainerId;
    const iframeStyles: CSSProperties = {
        display: "none",
        visibility: "hidden",
    };

    // VWO + GTM blocking pattern
    const vwoAndGtmBlocker = `
(function(nonVWOScriptsToExecute, VWO_HARD_TIMEOUT) {
  window._vwo_evq = window._vwo_evq || [];
  var queue = window._vwo_evq;
  for (var i = 0; i < queue.length; i++) {
    if (queue[i][0] === 'rD') {
      window.willRedirectionOccur = true;
      break;
    }
  }
  var _vwoOldPush = window._vwo_evq.push;
  window._vwo_evq.push = function() {
    var eventData = arguments[0],
      willRedirectionOccur;
    if (eventData[0] === 'rD') {
      willRedirectionOccur = eventData[1];
      window.willRedirectionOccurByVWO = willRedirectionOccur;
    }
    _vwoOldPush.apply(window._vwo_evq, [].slice.call(arguments));
  };
  var hardLimitTimedout = false;

  function tryNonVWOTracking(nonVWOScriptsToExecute) {
    if ((window._vwo_code && (window._vwo_code.finished() || window._vwo_code.libExecuted)) || hardLimitTimedout) {
      if (!window.willRedirectionOccurByVWO) {
        clearTimeout(hardLimitTimer);
        for (var i = 0; i < nonVWOScriptsToExecute.length; i++) {
          try {
            nonVWOScriptsToExecute[i]();
          } catch (e) {}
        }
        return;
      }
    }
    setTimeout(function() {
      tryNonVWOTracking(nonVWOScriptsToExecute)
    }, 500)
  }

  var hardLimitTimer = setTimeout(function() {
    hardLimitTimedout = true;
  }, VWO_HARD_TIMEOUT);
  tryNonVWOTracking(nonVWOScriptsToExecute);
})([function() {
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleTagManagerContainerId || ""}');
}], 5000);
`;

    return (
        <>
            {/* Google Optimize if present */}
            {googleOptimizeContainerId && (
                <Script
                    id="googleoptimize"
                    src={`https://www.googleoptimize.com/optimize.js?id=${encodeURIComponent(
                        googleOptimizeContainerId
                    )}`}
                    strategy="afterInteractive"
                />
            )}
            {/* VWO+GTM block logic */}
            {googleTagManagerContainerId && (
                <Script
                    id="vwo-gtm-blocker"
                    strategy="afterInteractive"
                    dangerouslySetInnerHTML={{ __html: vwoAndGtmBlocker }}
                />
            )}
        </>
    );
};
